export default {
  addMeasuringAttribute: {
    server: '/projects/{projectId}/measuring-points/{measuringPointId}/measuring-attributes',
    method: 'post',
  },
  getMeasuringAttributes: {
    server: '/projects/{projectId}/measuring-points/{measuringPointId}/measuring-attributes',
    method: 'get',
  },
  putMeasuringAttribute: {
    server: '/projects/{projectId}/measuring-points/{measuringPointId}/measuring-attributes/{measuringAttributeId}',
    method: 'put',
  },
  deleteMeasuringAttribute: {
    server: '/projects/{projectId}/measuring-points/{measuringPointId}/measuring-attributes/{measuringAttributeId}',
    method: 'delete',
  },
  getMeasuringAttributeTypeOptions: {
    server: '/constants/measuring-attribute-type-options',
    method: 'get',
  },
  getMeasurementFields: {
    server: '/constants/measurement-fields/{category}',
    method: 'get',
  },
};
